<mat-drawer-container class="asset-sidenav-container">
    <mat-drawer mode="push" position="end" [(opened)]="showEditSidenav">
        <form [formGroup]="valuationForm" *ngIf="sideNavMode == 'addValuation' || sideNavMode == 'editValuation'">
            <div fxLayout="column" class="asset-sidenav-form-container">
                <h3>{{sideNavMode == 'editValuation' ? 'Edit' : 'Add'}} Valuation</h3>
                <mat-form-field floatLabel="always">
                    <mat-label>Valuation</mat-label>
                    <input matInput type="number" class="asset-right-align" formControlName="valPriceCtl">
                    <span matTextPrefix>$&nbsp;</span>
                    <span matTextSuffix>.00</span>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>At</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="valDateCtl">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <div fxLayout="row" fxLayoutAlign="center">
                    <button mat-raised-button color="accent" (click)="closeEditSidenav()">Cancel</button>&nbsp;
                    <button mat-raised-button color="primary" (click)="saveEditSidenav()"
                        [disabled]="!valuationForm.valid">{{sideNavMode == 'editValuation' ? 'Update' : 'Add'}}</button>
                </div>
            </div>
        </form>
    </mat-drawer>
    <mat-drawer-content>
        <form [formGroup]="assetForm">
            <div class="asset-detail-container">
                <div *ngIf="loadingAssets == true">
                    <h2>Loading asset...</h2>
                </div>
                <div *ngIf="loadingAssets == false" fxLayout="column">
                    <h2 style="text-align: center;">{{isEdit == true ? 'Update':'New'}} Asset</h2>
                    <mat-form-field>
                        <mat-label>Name</mat-label>
                        <input matInput formControlName="nameCtl">
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Description</mat-label>
                        <input matInput formControlName="descriptionCtl">
                    </mat-form-field>
                    <div fxLayout="column" fxLayout.gt-xs="row">
                        <mat-form-field floatLabel="always">
                            <mat-label>Purchase</mat-label>
                            <input matInput formControlName="purchasePriceCtl" type="number" class="asset-right-align">
                            <span matTextPrefix>$&nbsp;</span>
                            <span matTextSuffix>.00</span>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>At</mat-label>
                            <input matInput [matDatepicker]="purchasePicker" formControlName="purchaseDateCtl">
                            <mat-datepicker-toggle matIconSuffix [for]="purchasePicker"></mat-datepicker-toggle>
                            <mat-datepicker #purchasePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div fxLayout="column" fxLayout.gt-xs="row">
                        <mat-form-field floatLabel="always">
                            <mat-label>Deposit</mat-label>
                            <input matInput formControlName="depositPriceCtl" type="number" class="asset-right-align">
                            <span matTextPrefix>$&nbsp;</span>
                            <span matTextSuffix>.00</span>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>At</mat-label>
                            <input matInput [matDatepicker]="depositPicker" formControlName="depositDateCtl">
                            <mat-datepicker-toggle matIconSuffix [for]="depositPicker"></mat-datepicker-toggle>
                            <mat-datepicker #depositPicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <mat-checkbox formControlName="isExploratoryCtl">Just exploring</mat-checkbox>
                    <h4><strong>Valuation History</strong></h4>
                    <table mat-table [dataSource]="vaulationsDataSource">
                        <ng-container matColumnDef="amountCol">
                            <th mat-header-cell *matHeaderCellDef>Amount</th>
                            <td mat-cell *matCellDef="let val">
                                {{val.Amount | currency}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="atCol">
                            <th mat-header-cell *matHeaderCellDef>At</th>
                            <td mat-cell *matCellDef="let val">
                                {{val.At | date : 'mediumDate'}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="actCol">
                            <th mat-header-cell *matHeaderCellDef class="asset-action-column-align">
                                <button mat-icon-button color="primary" aria-label="Add"
                                    (click)="openSidenav('addValuation')">
                                    <mat-icon>add_circle</mat-icon>
                                </button>
                            </th>
                            <td mat-cell *matCellDef="let val; let i = index" class="asset-action-column-align">
                                <button mat-icon-button color="primary" aria-label="Edit"
                                    (click)="openSidenav('editValuation', i)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-icon-button color="primary" aria-label="Remove">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <div *ngIf="vaulationsDataSource.data.length == 0" class="asset-no-records-container">
                        <p>
                            No valuation details recorded
                        </p>
                    </div>
                    <p>&nbsp;</p>
                    <div fxLayout="row" fxLayoutAlign="start">
                        <button mat-raised-button color="accent" (click)="cancel()">{{ this.assetForm.dirty ? 'Cancel' :
                            'Back'}}</button>&nbsp;
                        <button mat-raised-button color="primary" [class.spinner]="saving" (click)="save()"
                            [disabled]="!assetForm.valid || !assetForm.dirty || saving || deleting">{{saving ?
                            'Saving...' : 'Save'}}</button>&nbsp;
                        <button mat-raised-button color="warn" [class.spinner]="deleting" (click)="delete()"
                            [disabled]="saving || deleting" *ngIf="isEdit == true">{{deleting ? 'Deleting...':
                            'Delete'}}</button>&nbsp;
                    </div>
                </div>
            </div>
        </form>
    </mat-drawer-content>
</mat-drawer-container>